import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import MetricCardSkeleton from "../MetricCardSkeleton";

interface EducationMetricsSkeletonProps {
    cardCount?: number;
}

const EducationMetricsSkeleton = ({
    cardCount = 5,
}: EducationMetricsSkeletonProps) => {
    return (
        <div className="h-screen">
            <div className="mx-4 space-y-1">
                <Skeleton height={8} width="95%" />
                <Skeleton height={8} width={180} />
            </div>

            <div className="mx-auto px-4 pb-8 pt-4">
                <div className="grid grid-cols-2 gap-4">
                    {Array.from({ length: cardCount }).map(
                        (_, index) => (
                            <MetricCardSkeleton
                                key={`education-metric-skeleton-${index}`}
                            />
                        )
                    )}
                </div>
            </div>
        </div>
    );
};

export default EducationMetricsSkeleton;